// extracted by mini-css-extract-plugin
export default {"container":"M3QfA1"};